import type { ISetting } from '@dakedake/types'
import { useCallback, useState } from 'react'
import { settingList as list, settingGet } from '@/services'

export default function useSetting() {
  const [settingList, setSettingList] = useState<ISetting[]>([])

  const getSettingList = useCallback(async () => {
    const res = await list()
    setSettingList(res.data)
  }, [])

  const getSetting = useCallback(async (key: string) => {
    const res = await settingGet({ key })
    return res.data
  }, [])

  return {
    settingList,
    getSettingList,
    getSetting
  }
}
